import { Component } from "@angular/core";

import {
  Palette,
  PaletteState
} from "@lantern/app/common/wayfarer/container/container-attributes/palette";

@Component({
  templateUrl: "./component-zoo.template.html"
})
export class ComponentZooComponent {
  palettes = Object.values(Palette);

  states = Object.values(PaletteState);
}
